/* tslint:disable */
/* eslint-disable */
/**
 * Mild Blue s.r.o. - Online Connect
 * Application allowing people to ask for admition in IKEM.
 *
 * The version of the OpenAPI document: development
 * Contact: support@mild.blue
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { DoctorInfoDtoIn } from './doctor-info-dto-in';
import { PatientInfoDtoIn } from './patient-info-dto-in';
import { UploadIdentificationDtoIn } from './upload-identification-dto-in';

/**
 * 
 * @export
 * @interface RegistrationDtoIn
 */
export interface RegistrationDtoIn {
    /**
     * 
     * @type {string}
     * @memberof RegistrationDtoIn
     */
    clinic: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationDtoIn
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RegistrationDtoIn
     */
    diagnoses: Array<string>;
    /**
     * 
     * @type {DoctorInfoDtoIn}
     * @memberof RegistrationDtoIn
     */
    doctorInfo: DoctorInfoDtoIn;
    /**
     * 
     * @type {string}
     * @memberof RegistrationDtoIn
     */
    formType: RegistrationDtoInFormTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RegistrationDtoIn
     */
    goal: string;
    /**
     * 
     * @type {PatientInfoDtoIn}
     * @memberof RegistrationDtoIn
     */
    patientInfo: PatientInfoDtoIn;
    /**
     * 
     * @type {Array<UploadIdentificationDtoIn>}
     * @memberof RegistrationDtoIn
     */
    uploads: Array<UploadIdentificationDtoIn>;
    /**
     * 
     * @type {string}
     * @memberof RegistrationDtoIn
     */
    urgency: RegistrationDtoInUrgencyEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum RegistrationDtoInFormTypeEnum {
    PatientRegistration = 'PATIENT_REGISTRATION',
    DoctorRegistration = 'DOCTOR_REGISTRATION',
    ReceiptOrder = 'RECEIPT_ORDER'
}
/**
    * @export
    * @enum {string}
    */
export enum RegistrationDtoInUrgencyEnum {
    Normal = 'NORMAL',
    Urgent = 'URGENT'
}



